/**
 * Format dates and times using Gregorian calendar and Western digits (0-9)
 * in all locales (including Arabic).
 *
 * @param {Date|string|number} date - Date to format
 * @param {string} [locale] - BCP-47 locale (e.g. 'en-US', 'ar-SA') for language only; calendar is always Gregorian, digits always Latin
 * @returns {string}
 */
export function formatDateTime(date, locale = 'en-US') {
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) return '';
  try {
    return new Intl.DateTimeFormat(locale, {
      calendar: 'gregory',
      numberingSystem: 'latn',
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    }).format(d);
  } catch {
    return new Intl.DateTimeFormat('en-US', {
      calendar: 'gregory',
      numberingSystem: 'latn',
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    }).format(d);
  }
}

/**
 * Format time only (Gregorian calendar, Western digits).
 *
 * @param {Date|string|number} date - Date to format
 * @param {string} [locale] - BCP-47 locale for language
 * @returns {string}
 */
export function formatTime(date, locale = 'en-US') {
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) return '';
  try {
    return new Intl.DateTimeFormat(locale, {
      calendar: 'gregory',
      numberingSystem: 'latn',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    }).format(d);
  } catch {
    return new Intl.DateTimeFormat('en-US', {
      calendar: 'gregory',
      numberingSystem: 'latn',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    }).format(d);
  }
}
